import { createAction } from "redux-actions";

import {
  GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES,
  SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS,
  SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  getWatchListEntries,
  getWatchListEntriesPending,
  getWatchListEntriesFulfilled,
  getWatchListEntriesRejected,
} = createAsyncActions(
  GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES,
  "getWatchListEntries"
);

export const setWatchListEntriesSearchFilters = createAction(
  SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS
);

export const setRiskNoEntriesMessage = createAction(
  SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/actions/getWatchListEntriesActions.js